import Vue from 'vue'
import firebase from 'firebase'

import Router from 'vue-router'

import Home from '@/views/Home'
import Register from '@/views/Register'
import Login from '@/views/Login'
import Courses from '@/views/Courses'
import AddCourse from '@/views/AddCourse'
import Course from '@/views/Course'
import AutoCollections from '@/views/AutoCollections'
import CourseManager from '@/views/CourseManager'
import Learn from '../views/learn.vue'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
      meta: {
        requiresGuest: true
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        requiresGuest: true
      }
    },
    {
      path: '/courses',
      name: 'Courses',
      component: Courses,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/add_course',
      name: 'AddCourse',
      component: AddCourse,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/course/:id',
      name: 'Course',
      component: Course,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/collections',
      name: 'AutoCollections',
      component: AutoCollections,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/course_manager',
      name: 'CourseManager',
      component: CourseManager,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/learn',
      name: 'Learn',
      component: Learn,
      meta: {
        requiresAuth: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  // Check for requiresAuth guard
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // Check if NO logged user
    if (!firebase.auth().currentUser) {
      // Go to login
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    } else {
      // Proceed to route
      next()
    }
  } else if (to.matched.some(record => record.meta.requiresGuest)) {
    // Check if NO logged user
    if (firebase.auth().currentUser) {
      // Go to login
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      })
    } else {
      // Proceed to route
      next()
    }
  } else {
    // Proceed to route
    next()
  }
})

export default router
